import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "{{wrapperClasses}}"
}
const _hoisted_2 = {
  key: 0,
  class: "text-center buttons-remove"
}
const _hoisted_3 = { class: "icon icon-start icon-me-2 icon-remove" }
const _hoisted_4 = { class: "icon icon-start icon-me-2 icon-remove" }
const _hoisted_5 = {
  key: 1,
  class: "text-center buttons-add-main"
}
const _hoisted_6 = { class: "icon icon-start icon-me-2 icon-add" }
const _hoisted_7 = {
  key: 0,
  class: "small d-block text-center"
}
const _hoisted_8 = {
  key: 2,
  class: "text-center buttons-add-alt"
}
const _hoisted_9 = { class: "icon icon-start icon-me-2 icon-add" }
const _hoisted_10 = {
  key: 0,
  class: "small d-block text-center"
}



  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  
export default /*#__PURE__*/_defineComponent({
  __name: 'SessionButtons',
  props: {
    session: { type: Object },
    wrapperClasses: {type: String },
    buttonLabelClasses: {type: String },
    isCartInSession: { type: Boolean },
    isEnrtySession: { type: Boolean },
    eventHolding: { type: Boolean },
  },
  emits: ['addItem', 'removeItem', 'cancelItem'],
  setup(__props, { emit: __emit }) {

  const props = __props

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const emits = __emit;
  const addItem = (id: string, reg_type='') => {
    emits('addItem', id, reg_type);
  }

  const removeItem = (layout_id: string) => {
    emits('removeItem', layout_id);
  }

  const cancelItem = (session: object) => {
    emits('cancelItem', session);
  }

return (_ctx: any,_cache: any) => {
  return (
	          	__props.eventHolding &&
	          	(
	          		(
	          			__props.session.regabel_status !== '0' &&
	          			__props.session.regabel_status !== '4'
	          		)
	          		||
	          		(
	          			'undefined'!=typeof(__props.session.regabel_status_alt) &&
	          			__props.session.regabel_status_alt !== '0' &&
	          			__props.session.regabel_status_alt !== '4'
	          		)
	          	)
	          )
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.isCartInSession || __props.isEnrtySession)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (__props.isCartInSession && !__props.isEnrtySession)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn btn-secondary w-100 session-remove", __props.buttonLabelClasses]),
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (removeItem(__props.session.layout_id)), ["stop","prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(__props.session.button_label_remove_from_cart), 1)
                  ], 2))
                : _createCommentVNode("", true),
              (__props.isEnrtySession)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn btn-secondary w-100 session-cancel", __props.buttonLabelClasses]),
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (cancelItem(__props.session)), ["stop","prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(__props.session.button_label_cancel), 1)
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
	          		!__props.isCartInSession &&
	          		!__props.isEnrtySession &&
		          	__props.session.regabel_status !== '0' &&
		          	__props.session.regabel_status !== '4'
		          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (
            			__props.session.regabel_status === '1' ||
            			__props.session.regabel_status === '2'
	            	)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn btn-accent2 w-100 session-add", __props.buttonLabelClasses]),
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (addItem(__props.session.layout_id, '')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(__props.session.button_label_add_to_cart), 1),
                    (__props.session.regabel_status === '2')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "（残席わずか）"))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (__props.session.regabel_status === '3')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn-cols-max btn btn-accent2 w-100 session-add disabled text-white", __props.buttonLabelClasses]),
                    disabled: "disabled"
                  }, "（満席）", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
	          		!__props.isCartInSession &&
	          		!__props.isEnrtySession &&
		          	'undefined' != typeof(__props.session.regabel_status_alt) &&
		          	__props.session.regabel_status_alt !== '0' &&
		          	__props.session.regabel_status_alt !== '4'
		          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (
	            		__props.session.regabel_status_alt === '1' ||
	            		__props.session.regabel_status_alt === '2'
		            )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn btn-accent2 w-100 session-add", __props.buttonLabelClasses]),
                    onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (addItem(__props.session.layout_id, 'alt')), ["stop","prevent"]))
                  }, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(__props.session.button_label_add_to_cart_alt), 1),
                    (__props.session.regabel_status_alt === '2')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "（残席わずか）"))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (__props.session.regabel_status_alt === '3')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: _normalizeClass(["h-100 btn-cols-max btn btn-accent2 w-100 session-add disabled text-white", __props.buttonLabelClasses]),
                    disabled: "disabled"
                  }, "（オンライン参加は満席）", 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})